import classNames from 'classnames';
import React, { useState } from 'react';

import { translate } from '@vestahealthcare/common/i18n';
import { PodMetricsSummaryCommon } from '@vestahealthcare/common/models';

import { Chip, Collapse, CollapseIcon, IconButton } from 'styleguide-v2';

import RecursiveTable from 'dash/src/components/RecursiveTable';

import { PODSummaryCardStyles } from './styles';

type Props = {
  className?: string;
  pod: PodMetricsSummaryCommon;
};

export const PodSummaryCardBiannual = ({ className, pod }: Props) => {
  const styles = PODSummaryCardStyles();
  const [openDetail, setOpenDetail] = useState<boolean>(false);

  return (
    <div className={className}>
      <div
        className={classNames(styles.itemContainer, 'clickable')}
        onClick={() => setOpenDetail(!openDetail)}
      >
        <span className={styles.subtitle}>
          {translate('pods.metrics.card.biannualSummary')}
        </span>
        <div className={styles.titleInfo}>
          <div className={styles.chipsContainer}>
            {pod.npBiannualDueCount !== undefined && (
              <Chip color="warning" type="contained-2">
                <span className="bold">Due: {pod.npBiannualDueCount}</span>
              </Chip>
            )}
            {pod.npBiannualOverdueCount !== undefined && (
              <Chip color="error" type="contained-2">
                <span className="bold">
                  Overdue: {pod.npBiannualOverdueCount}
                </span>
              </Chip>
            )}
          </div>
          <IconButton
            className={styles.titleInfoCollapse}
            onClick={() => setOpenDetail(!openDetail)}
            size="small"
          >
            <CollapseIcon open={openDetail} />
          </IconButton>
        </div>
      </div>
      <Collapse open={openDetail}>
        <div className={classNames(styles.itemContainer, 'flex center')}>
          <RecursiveTable
            data={[
              {
                name: translate('common.status.completed'),
                column1: pod.npBiannualCompletedDueCount,
                column2: pod.npBiannualCompletedOverdueCount,
              },
              {
                name: translate('common.status.pending'),
                column1: pod.npBiannualPendingDueCount,
                column2: pod.npBiannualPendingOverdueCount,
              },
              {
                name: translate('pods.metrics.card.rescheduleNeeded'),
                column1: pod.npBiannualRescheduleDueCount,
                column2: pod.npBiannualRescheduleOverdueCount,
              },
              {
                name: translate('pods.metrics.card.notYetScheduled'),
                column1: pod.npBiannualNotYetDueCount,
                column2: pod.npBiannualNotYetOverdueCount,
              },
            ]}
            header=" "
            header1={translate('pods.metrics.card.due')}
            header2={translate('pods.metrics.card.overdue')}
          />
        </div>
      </Collapse>
    </div>
  );
};
